import { IMovimentationStep } from '../../movimentationSteps';
import { ConfirmationLayout } from './layout';

const ConfirmationStep: IMovimentationStep = {
  name: 'Confirmação',
  step: (props: any) => <ConfirmationLayout {...props} />,
};

export default ConfirmationStep;
